import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fd6a0b88&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd6a0b88')) {
      api.createRecord('fd6a0b88', component.options)
    } else {
      api.reload('fd6a0b88', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fd6a0b88&", function () {
      api.rerender('fd6a0b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/offershelp.vue"
export default component.exports